import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Road = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 18C15.448 18 15 17.552 15 17V13C15 12.448 15.448 12 16 12C16.552 12 17 12.448 17 13V17C17 17.552 16.552 18 16 18Z" />
		<path d="M27.965 26.742C27.965 26.74 21.965 4.737 21.965 4.737C21.846 4.302 21.451 4 21 4H11C10.549 4 10.154 4.302 10.035 4.737C10.035 4.737 4.035 26.741 4.035 26.742C4.013 26.824 4 26.911 4 27C4 27.552 4.448 28 5 28H27C27.552 28 28 27.552 28 27C28 26.911 27.987 26.825 27.965 26.742ZM17 26V23C17 22.448 16.552 22 16 22C15.448 22 15 22.448 15 23V26H6.309L11.764 6H15V7C15 7.552 15.448 8 16 8C16.552 8 17 7.552 17 7V6H20.236L25.691 26H17Z" />
		<path d="M20.259 27.198C20.5 27.198 20.501 26.823 20.259 26.823C20.017 26.823 20.017 27.198 20.259 27.198Z" />
	</svg>
);

export default Road;
